/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Set_As_Track_2Inputs */

const en_event_group_options_set_as_track_2 = /** @type {(inputs: Event_Group_Options_Set_As_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set As Track 2`)
};

const fr_event_group_options_set_as_track_2 = /** @type {(inputs: Event_Group_Options_Set_As_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Définir comme piste 2`)
};

const de_event_group_options_set_as_track_2 = /** @type {(inputs: Event_Group_Options_Set_As_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Track 2 festlegen`)
};

const it_event_group_options_set_as_track_2 = /** @type {(inputs: Event_Group_Options_Set_As_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imposta come traccia 2`)
};

const ru_event_group_options_set_as_track_2 = /** @type {(inputs: Event_Group_Options_Set_As_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Установить как трек 2`)
};

const es_event_group_options_set_as_track_2 = /** @type {(inputs: Event_Group_Options_Set_As_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Establecer como pista 2`)
};

const zh_cn2_event_group_options_set_as_track_2 = /** @type {(inputs: Event_Group_Options_Set_As_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置为轨道 2`)
};

const ja_event_group_options_set_as_track_2 = /** @type {(inputs: Event_Group_Options_Set_As_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トラック2として設定`)
};

const hi_event_group_options_set_as_track_2 = /** @type {(inputs: Event_Group_Options_Set_As_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रैक 2 के रूप में सेट करें`)
};

const pt_pt2_event_group_options_set_as_track_2 = /** @type {(inputs: Event_Group_Options_Set_As_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definir como faixa 2`)
};

/**
* | output |
* | --- |
* | "Set As Track 2" |
*
* @param {Event_Group_Options_Set_As_Track_2Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_set_as_track_2 = /** @type {((inputs?: Event_Group_Options_Set_As_Track_2Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Set_As_Track_2Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_set_as_track_2(inputs)
	if (locale === "de") return de_event_group_options_set_as_track_2(inputs)
	if (locale === "it") return it_event_group_options_set_as_track_2(inputs)
	if (locale === "ru") return ru_event_group_options_set_as_track_2(inputs)
	if (locale === "es") return es_event_group_options_set_as_track_2(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_set_as_track_2(inputs)
	if (locale === "ja") return ja_event_group_options_set_as_track_2(inputs)
	if (locale === "hi") return hi_event_group_options_set_as_track_2(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_set_as_track_2(inputs)
	return en_event_group_options_set_as_track_2(inputs)
});